var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartY(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24 / basic / heart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8298 3.00002C22.6583 3 21.2586 3.2587 19.654 4.04411C19.0599 4.3349 18.5026 4.68509 17.985 5.09364C17.4873 4.70799 16.9522 4.37388 16.3827 4.0922C14.747 3.28316 13.2754 3 11.1818 3C5.57466 3 1.5 7.6459 1.5 13.6798C1.5 18.2366 4.04075 22.6384 8.77326 26.8948C11.2573 29.129 14.429 31.34 16.7004 32.5162L18 33.1892L19.2996 32.5162C21.571 31.34 24.7427 29.129 27.2267 26.8948C31.9593 22.6384 34.5 18.2366 34.5 13.6798C34.5 7.70977 30.3869 3.02304 24.8298 3.00002ZM31.5 13.6798C31.5 17.2498 29.3793 20.924 25.2206 24.6643C22.9533 26.7035 20.0385 28.7414 18 29.8105C15.9616 28.7414 13.0468 26.7035 10.7794 24.6643C6.62076 20.924 4.50003 17.2498 4.50003 13.6798C4.50003 9.22156 7.32549 5.99999 11.1818 5.99999C12.8465 5.99999 13.8722 6.19737 15.0527 6.78125C15.75 7.12614 16.3663 7.58154 16.8998 8.15064L18.0035 9.32804L19.0972 8.14131C19.6427 7.54941 20.268 7.08364 20.9729 6.73862C22.1188 6.17772 23.0805 5.99999 24.8237 6C28.6323 6.01578 31.5 9.28343 31.5 13.6798Z",
    fill: "#5f4b32"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartY);
export default __webpack_public_path__ + "static/media/heartY.b25ae73039c8ebecf436fb2a22ebc57a.svg";
export { ForwardRef as ReactComponent };